/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CommunicationsResourceChangedNotification = {
    eventType: CommunicationsResourceChangedNotification.eventType;
    eventId: string;
    tenantId: string;
    funnelConversationId: number;
    funnelId?: number;
    resourceType: CommunicationsResourceChangedNotification.resourceType;
    resourceId: string;
    occurredAt: string;
};
export namespace CommunicationsResourceChangedNotification {
    export enum eventType {
        COMMUNICATIONS_RESOURCE_CHANGED = 'communications.resource.changed',
    }
    export enum resourceType {
        MESSAGE = 'Message',
        CONVERSATION = 'Conversation',
        STATUS_HISTORY = 'StatusHistory',
        CHANNEL_SESSION = 'ChannelSession',
        CALL = 'Call',
    }
}

